import React from 'react';
import { useClientRender } from 'hooks/useClientRender';

const withClientSideRenderOnly = () => WrappedComponent => {
    const WithClientSideRenderOnly = function (props) {
        const isClient = useClientRender();

        if (!isClient) {
            return null;
        }

        return <WrappedComponent {...props} />;
    };

    const wrappedName = WrappedComponent.displayName || WrappedComponent.class;
    WithClientSideRenderOnly.prototype.class = `WithClientSideRenderOnly-${wrappedName}`;
    WithClientSideRenderOnly.class = `WithClientSideRenderOnly-${wrappedName}`;
    WithClientSideRenderOnly.displayName = `WithClientSideRenderOnly(${wrappedName})`;

    return WithClientSideRenderOnly;
};

export default withClientSideRenderOnly;
